// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { xGaState } from '@adl/App/Store/Reducers/xGA';
import { getDataLayer } from "@adl/XDL/Utilities";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, SendTracking } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";


export const _GaSendTracking = (props: any) => {
    const { search } = props.apiParameter;

    if (!search) {
        return;
    }

    const state = props.getState();
    const pagination = getProductListDataViewProperty(state, "pagination");
    const originalQuery = getProductListDataViewProperty(state, "originalQuery");
    const correctedQuery = getProductListDataViewProperty(state, "correctedQuery");
    
    if (state.xGA.signInEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: "search",
            search_term: originalQuery,
            corrected_term: correctedQuery,
            numSearchresults: pagination?.totalItemCount
        }

        dataLayer.push(googleAnalyticsData);
    }
};

addToChainAfter(chain, SendTracking, _GaSendTracking);